import Approval from '@/pages/Approval';
import ForApproval from '@/pages/ForApproval';

export default [
  {
    path: '/for-approval',
    component: ForApproval,
    meta: {
      title: '',
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'for-approval',
        redirect: { name: 'approval.timesheet' },
      },
      {
        path: 'timesheet',
        name: 'approval.timesheet',
        meta: {
          type: 'timesheet',
          permissions: ['perm_view_pending_approvals'],
        },
      },
      {
        path: 'overtime',
        name: 'approval.overtime',
        meta: {
          type: 'overtime',
          permissions: ['perm_view_all_pending_overtime'],
        },
      },
      {
        path: 'ob',
        name: 'approval.ob',
        meta: {
          type: 'ob',
          permissions: ['perm_view_all_pending_ob'],
        },
      },
    ],
  },
  {
    path: '/for-approval/:key',
    name: 'approval',
    component: Approval,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_approve_timesheet'],
    },
  },
];
